import classNames from 'classnames/bind';
import React from 'react';

import styles from './LabelGroup.module.scss';

const cx = classNames.bind(styles);

const LabelGroup = ({ label, htmlFor, labelFontSize, children }) => {
  return (
    <div className={cx('container')}>
      <label htmlFor={htmlFor} style={labelFontSize && { fontSize: labelFontSize }}>
        {label}
      </label>
      {children}
    </div>
  );
};

export default LabelGroup;
